import PropTypes from 'prop-types';
import React from 'react';

import { cls } from '@mssgme/helpers';
import Checkbox from '../Checkbox';

import styles from './Toggle.scss';

export default function Toggle(props) {
    return <Checkbox styled="toggle" {...cls(styles.root, props)} />;
}

Toggle.propTypes = {
    className: PropTypes.string,
    placeholder: PropTypes.any,
    hasError: PropTypes.bool,
    disabled: PropTypes.bool,
    builderInput: PropTypes.bool,
};
